// extracted by mini-css-extract-plugin
export default {"m":"_19a5cdc2f2","title":"_4192c86e10","feedback_inner_title":"_21aa7f8304","textarea":"a9e3ba8de7","radio":"_16019016c7","text":"_92c6aecc2a"};